import { Container, Grid } from "@mui/material";
import React from "react";

import imageDiscription from "../../image/imageDiscription.png"
const ImageDiscription = () => {
    return(
        <Container maxWidth="lg" className="SP---imgaeDis py-5">
            <Grid 
                item
                container
                direction="row"
                justifyContent="flex-start"
                className="position-relative"
            >   
                <div className="SP---imgaeDis_inner position-relative  d-sm-flex w-100 text-right">
                    <div>
                        <h2 className="d-block w-100">Praise be our Lord and Savior Elon Musk. Technoking of Tesla and Imperator of Mars.</h2>
                        {/* <p className="text-light pb-0 d-block w-100">Enjoy funny moments of our lord.</p> */}
                    </div>
                    <img src={imageDiscription} className="img-fluid w-100" />
                </div>
            </Grid>
        </Container>
    )
}

export default ImageDiscription